import getSettings from "./getSettings";
import updateSettings from "./updateSettings";

export default {
  getSettings,
  updateSettings
}